import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ParseUser } from 'app/core/user/parse-user.model';
import { UserService } from 'app/core/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class SyzlEmailGuard {
  constructor(
    private router: Router,
    private _userService: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkSyzlEmail();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkSyzlEmail();
  }

  private checkSyzlEmail(): Observable<boolean> {
    const user = ParseUser.current() as ParseUser;

    if (!user || !user.email) {
      this.router.navigate(['sign-in']);
      return of(false);
    }

    // Check if email ends with @syzl.io
    if (!user.email.endsWith('@syzl.io')) {
      this.router.navigate(['dashboard']);
      return of(false);
    }

    return of(true);
  }
}
